import { render, staticRenderFns } from "./AdditionalResource.vue?vue&type=template&id=67a6b976"
import script from "./AdditionalResource.vue?vue&type=script&lang=ts"
export * from "./AdditionalResource.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports